import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import $ from 'jquery';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import ModalMenu from '../Modal/MMenu.jsx';
import ULanding from '../../../../Utils/ULanding.jsx';

export default function TbMenu() {
 const [DataModal, setDataModal] = useState()
 const [modal, setModal] = useState(false)
 const [menu, setMenu] = useState()
 const [feed, setFeedBack] = useState()

 const getData = () => {
  try {
   ULanding.getMenu().then((res) => {
    setMenu(res.data)
    tableConfig();
   })
  } catch (error) {
   toast.error(error, {
    position: toast.POSITION.TOP_RIGHT
   })
  }
 }

 const tableConfig = () => {
  setTimeout(function () {
   $('.table').DataTable({
    pageLength: 1000,
    processing: true,
    retrieve: true,
    dom: 'Bfrtip',
    order: [[2, 'asc']],
    buttons: [
     {
      extend: "pageLength",
      class: "btn bg-topbar",
     },
     'copy', 'csv', 'excel', 'pdf', 'print',
    ],
   });
  }, 1000);
 }

 const handleModal = (e) => {
  setModal(!modal)
  const target = e.currentTarget
  const id = target.getAttribute('data-id')
  const mdl = target.getAttribute('data-modal')
  var max =  Math.max(...menu.map(({ urut }) => urut))+1
  console.log(id);
  setDataModal({ id, mdl, max })
 }

 const feedBack = (fb) => {
  $('.table').DataTable().destroy()
  getData();
  if (fb.stat > 0) {
   toast.success(fb.msg, {
    position: toast.POSITION.TOP_RIGHT
   })
  } else {
   toast.error(fb.msg, {
    position: toast.POSITION.TOP_RIGHT
   })
  }
 }

 useEffect(() => {
  getData()
 }, [])
 return (
  <>
   <ToastContainer pauseOnHover />
   <div class="card">
    <div class="card-header">
     <h3 class="card-title">
      Menu
      <button type='button' className='btn bg-info' data-modal="add" style={{ marginLeft: '20px' }} onClick={(e) => handleModal(e)}>
       <i class="fas fa-plus text-white"></i>
      </button>
     </h3>
    </div>
    <div class="card-body table-responsive p-0" style={{ height: '500px' }}>
     <table class="table table-head-fixed text-nowrap">
      <thead>
       <tr>
        <th>Menu</th>
        <th>Link</th>
        <th>Urut</th>
        <th>Act</th>
       </tr>
      </thead>
      <tbody>
       {menu ? menu.map((row, index) => {
        return (
         <>
          <tr>
           <td>{row.menu}</td>
           <td>{row.link}</td>
           <td>{row.urut}</td>
           <td>
            <button type='button' className='btn btn-sm bg-warning' data-modal="upd" data-id={row.id} onClick={(e) => handleModal(e)}>
             <i class="fas fa-edit text-white"></i>
            </button>
            <button type='button' className='btn btn-sm bg-danger' data-modal="del" data-id={row.id} onClick={(e) => handleModal(e)}>
             <i class="fas fa-trash text-white"></i>
            </button>
           </td>
          </tr>
         </>
        )
       }) : null}
      </tbody>
     </table>
    </div>
   </div>
   <Modal show={modal} onHide={() => setModal(false)}>
    <ModalMenu data={DataModal} feedBack={feedBack} />
   </Modal>
  </>
 )
}